<template>
  <div class="preview-container">
    <div class="preview-area" :class="[`size-${size}`]" ref="iframeParent">
      <!-- 插入iframe -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'print',
  props: {
    size: {
      type: String,
      default: 'A4',
    },
    data: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    template: [String],
  },
  data() {
    return {
      instance: null,
    };
  },
  methods: {
    doPrint() {
      this.instance.print();
    },
    getHtml() {
      return this.instance.getHtml();
    },
  },
  created() {
    this._pro = app.libs.getArtTemplate().then(template => {
      template.defaults.imports.htmlFormat = function htmlFormat(val) {
        return val.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
      };
    });
  },
  mounted() {
    this._pro.then(() => {
      this.instance = app.buildPrint({
        source: this.template,
        data: this.data,
      });
      this.instance.preview(this.$refs.iframeParent);
    });
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  .size-A4 {
    // 210mm * 297mm
    width: 840px;
    height: 1188px;
  }
}
</style>
